import { ScopeContext } from '@sentry/core';

import { throwErrorUnlessProduction } from '../errors';
import { isPresent } from './isPresent';

/** Throws outside production; in production it reports the missing value and returns it anyway. */
export function assertPresent<T>(
    x: T | null | undefined,
    options?: { errorMessage?: string; captureOptions?: Partial<ScopeContext> },
): Exclude<T, undefined | null> {
    if (!isPresent(x)) {
        const errorMessage = options?.errorMessage ?? `Expected value to be present but got ${x}`;
        throwErrorUnlessProduction(new Error(errorMessage), options?.captureOptions);
    }
    // This case is safe as this code is only reachable if x isPresent

    return x as Exclude<T, undefined | null>;
}
